import { Box, Button, Container, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAllBanners } from "../firebase/fireStoreServices";

export default function HeroSection() {
  const [banners, setBanners] = useState([]);
  const [currentBanner, setCurrentBanner] = useState(0);
  const [isLoadin, setIsLoading] = useState(true);
  const placeholderImage = "/images/banners/CookingBanner_Sweets.jpg"; // Use a default banner image

  const navigate = useNavigate();

  // Fetching Banner data from database through service layer i.e. firebase/fireStoreServices
  useEffect(() => {
    const loadBannersData = async () => {
      setIsLoading(true);
      const bannersData = await fetchAllBanners();
      setBanners(bannersData);
      setIsLoading(false);
    };
    loadBannersData();
  }, []);

  useEffect(() => {
    if (banners.length === 0) return;
    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 3000); // Change banner every 3 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [banners.length]);

  return (
    <>
      {/* Hero Section  */}
      {banners.length > 0 && (
        <Box
          maxWidth="lg"
          sx={{
            p: 2,
            backgroundImage: `url(${
              banners.length > 0
                ? banners[currentBanner].image
                : placeholderImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "50vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color: "white",
            transition: "opacity 0.5s ease-in-out",
            borderRadius: 5,
            width: "100%", // Ensure full width
            m: 0, // Remove margin pushing it inward
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: "bold",
                mb: 2,
                fontFamily: "'Dancing Script', cursive",
                color: "#F8F8F8",
                textShadow: "2px 2px 10px rgba(0, 0, 0, 0.5)",
              }}
            >
              {banners[currentBanner].title}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                fontFamily: "'Poppins', sans-serif",
                fontSize: "1.5rem",
                color: "#F8F8F8",
                textShadow: "1px 1px 8px rgba(0, 0, 0, 0.3)",
              }}
            >
              {banners[currentBanner].subTitle}
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              onClick={() => navigate("/recipeList")}
              sx={{ mt: 2 }}
            >
              Explore Recipes
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
}
